import { GetUnacknowledgedLevelsResponse } from "../api/queries/getUnacknowledgedLevelsQuery";

import { ParsedUnacknowledgedLevel } from "./useGetUnacknowledgedLevels";

export function parseUnacknowledgedLevels(
  response: GetUnacknowledgedLevelsResponse
): ParsedUnacknowledgedLevel[] {
  const { data, included } = response;
  const mappedUnacknowledgedLevels = data.map((level) => {
    const currentLevelGroup = included.find(
      (userGroup) => userGroup.id === level.relationships.userGroup.data.id
    );

    return {
      id: level.id,
      levelName: level.attributes.name,
      order: level.attributes.order,
      group: currentLevelGroup && {
        id: currentLevelGroup.id,
        name: currentLevelGroup.attributes.name,
        colorHex: currentLevelGroup.attributes.colorHex,
      },
    };
  });
  return mappedUnacknowledgedLevels.sort((firstLevel, secondLevel) =>
    firstLevel.levelName.localeCompare(secondLevel.levelName)
  );
}
